<script>
import {mapGetters, mapActions} from 'vuex'
import {ERROR_GENERIC} from '../../utils/messages'
import {FAKE_ACTIVE, WS_URL} from '../../utils/config'
import Vue from 'vue'

export default {
  name: 'CompletaPraticaAction',
  methods: {
    ...mapGetters(['getSearch', 'getFlightFrom', 'getFlightsFrom', 'getFlightTo', 'getFlightsTo', 'getSpeseAccessorieSelected']),
    ...mapActions(['loadingStart', 'loadingEnd', 'loadPreventivo']),
    completaPratica () {
      return FAKE_ACTIVE ? this.completaPraticaFake() : this.completaPraticaReal()
    },
    completaPraticaReal () {
      const list = this.getSpeseAccessorieSelected().map(item => {
        return {itemId: item.itemId, prezzo: item.prezzo}
      })
      const payload = {
        items: list
      }
      this.loadingStart()
      return new Promise((resolve, reject) => {
        Vue.axios.post(`${WS_URL}extra`, payload, {withCredentials: true}).then(response => {
          // public class ChiusuraFlexy extends ActionPreventivo {
          //    private Integer numeroPratica;
          //    private String urlStampaFlexy;
          const data = response.data
          if (!data.done && data.messages) {
            const error = {error: true, messages: data.messages}
            this.$toastr.error(ERROR_GENERIC)
            reject(error)
          } else {
            this.loadPreventivo(data)
            resolve(response)
          }
        }).catch(() => {
          this.$toastr.error(ERROR_GENERIC)
        }).finally(() => {
          this.loadingEnd()
        })
      })
    },
    completaPraticaFake () {
      return new Promise((resolve) => {
        this.loadPreventivo({
          numeroPratica: 12345,
          urlStampaFlexy: 'http://www.ansa.it'
        })
        resolve('success')
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/actions/CompletaPraticaAction.vue